import { render, staticRenderFns } from "./homePrizePool.vue?vue&type=template&id=55ff5b58&"
import script from "./homePrizePool.vue?vue&type=script&lang=js&"
export * from "./homePrizePool.vue?vue&type=script&lang=js&"
import style0 from "./homePrizePool.vue?vue&type=style&index=0&id=55ff5b58&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports